import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {CircularGauge as DXCircularGauge} from 'devextreme-react/circular-gauge';


export default class CircularGauge extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value,
            target: this.props.target
        };
    }

    // UNSAFE_componentWillReceiveProps(props) {
    //     if (
    //         (this.state.value !== props.value)
    //         || (this.state.target !== props.target)
    //     ) {
    //         this.setState({
    //             value: props.value,
    //             target: props.target,
    //         })
    //     }
    // }

    static getDerivedStateFromProps(nextProps, prevState){
        if ((nextProps.value !== prevState.value) || (nextProps.target !== prevState.target)) {
            return {
                value: nextProps.value,
                target: nextProps.target,
            };
        }
        return null;
    }

    render() {
        return (
            <DXCircularGauge
                {...this.props}
                value={this.state.value}
                target={this.state.target}
            />
        )
    }
}

CircularGauge.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,

    animation: PropTypes.object,
    containerBackgroundColor: PropTypes.string,
    disabled: PropTypes.bool,
    elementAttr: PropTypes.object,
    export: PropTypes.object,
    geometry: PropTypes.object,
    loadingIndicator: PropTypes.object,
    margin: PropTypes.object,
    onDisposing: PropTypes.func,
    onDrawn: PropTypes.func,
    onExported: PropTypes.func,
    onExporting: PropTypes.func,
    onFileSaving: PropTypes.func,
    onIncidentOccurred: PropTypes.func,
    onInitialized: PropTypes.func,
    onOptionChanged: PropTypes.func,
    onTooltipHidden: PropTypes.func,
    onTooltipShown: PropTypes.func,
    pathModified: PropTypes.bool,
    rangeContainer: PropTypes.object,
    redrawOnResize: PropTypes.bool,
    rtlEnabled: PropTypes.bool,
    scale: PropTypes.object,
    size: PropTypes.object,
    subvalueIndicator: PropTypes.object,
    subvalues: PropTypes.arrayOf(PropTypes.number),
    theme: PropTypes.oneOf(['generic.dark', 'generic.light', 'generic.contrast', 'ios7.default', 'generic.carmine', 'generic.darkmoon', 'generic.darkviolet', 'generic.greenmist', 'generic.softblue', 'material.blue.light', 'material.lime.light', 'material.orange.light', 'material.purple.light', 'material.teal.light']),
    title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    tooltip: PropTypes.object,
    value: PropTypes.number,
    valueIndicator: PropTypes.object,

    setProps: PropTypes.func
};

CircularGauge.defaultProps = {
    animation: {
        // duration: 1000,
        // easing: 'easeOutCubic',
        // enabled: true
    },
    containerBackgroundColor: 'none',
    disabled: false,
    elementAttr: {},
    export: {
        // backgroundColor: '#ffffff',
        // enabled: false,
        // fileName: 'file',
        // formats: "['PNG",
        // margin: 10,
        // printingEnabled: true,
        // // svgToCanvas: undefined
    },
    geometry: {
        // endAngle: 315,
        // startAngle: 225
    },
    loadingIndicator: {
        // backgroundColor: '#FFFFFF',
        // font: {
        //     color: '#767676',
        //     family: 'Segoe UI',
        //     opacity: 1,
        //     size: 12,
        //     weight: 400
        // },
        // show: false,
        // text: 'Loading...'
    },
    margin: {
        // bottom: 0,
        // left: 0,
        // right: 0,
        // top: 0
    },
    onDisposing: null,
    onDrawn: null,
    onExported: null,
    onExporting: null,
    onFileSaving: null,
    onIncidentOccurred: null,
    onInitialized: null,
    onOptionChanged: null,
    onTooltipHidden: null,
    onTooltipShown: null,
    pathModified: false,
    rangeContainer: {
        // backgroundColor: '#808080',
        // offset: 0,
        // orientation: 'outside',
        // palette: 'Material',
        // paletteExtensionMode: 'blend',
        // ranges: [
        //     {
        //         color: null,
        //         endValue: null,
        //         startValue: null
        //     }
        // ],
        // width: 5
    },
    redrawOnResize: true,
    rtlEnabled: false,
    scale: {
        // allowDecimals: undefined,
        // customMinorTicks: undefined,
        // customTicks: undefined,
        // endValue: 100,
        // label: {
        //     customizeText: null,
        //     font: {
        //         color: '#767676',
        //         family: 'Segoe UI',
        //         opacity: 1,
        //         size: 12,
        //         weight: 400
        //     },
        //     format: undefined,
        //     hideFirstOrLast: 'last',
        //     indentFromTick: 10,
        //     overlappingBehavior: 'hide',
        //     useRangeColors: false,
        //     visible: true
        // },
        // minorTick: {
        //     color: '#FFFFFF',
        //     length: 3,
        //     opacity: 1,
        //     visible: false,
        //     width: 1
        // },
        // minorTickInterval: undefined,
        // orientation: 'outside',
        // scaleDivisionFactor: 17,
        // startValue: 0,
        // tick: {
        //     color: '#FFFFFF',
        //     length: 5,
        //     opacity: 1,
        //     visible: true,
        //     width: 2
        // },
        // tickInterval: undefined
    },
    size: {
        // height: undefined,
        // width: undefined
    },
    subvalueIndicator: {
        // arrowLength: 5,
        // backgroundColor: 'none',
        // baseValue: undefined,
        // beginAdaptingAtRadius: 50,
        // color: null,
        // horizontalOrientation: 'right',
        // indentFromCenter: 0,
        // length: 15,
        // offset: null,
        // palette: 'Material',
        // secondColor: '#E18E92',
        // secondFraction: 0.4,
        // size: 10,
        // spindleGapSize: 10,
        // spindleSize: 14,
        // text:  {
        //     customizeText: undefined,
        //     font:  {
        //         color: null,
        //         family: 'Segoe UI',
        //         opacity: 1,
        //         size: 14,
        //         weight: 400
        //     },
        //     format: undefined,
        //     indent: 0
        // },
        // type: 'triangleMarker',
        // verticalOrientation: 'bottom',
        // width: 2
    },
    // subvalues: [],
    theme: 'generic.light',
    title: '',
    // title: {
    //     font:  {
    //         color: '#232323',
    //         family: 'Segoe UI Light',
    //         opacity: 1,
    //         size: 28,
    //         weight: 200
    //     },
    //     horizontalAlignment: 'center',
    //     margin:  {
    //         bottom: 10,
    //         left: 10,
    //         right: 10,
    //         top: 10
    //     },
    //     placeholderSize: undefined,
    //     subtitle:  {
    //         font:  {
    //             color: '#232323',
    //             family: 'Segoe UI Light',
    //             opacity: 1,
    //             size: 16,
    //             weight: 200
    //         },
    //         offset: 0,
    //         text: null,
    //         textOverflow: 'ellipsis',
    //         wordWrap: 'normal'
    //     },
    //     text: null,
    //     textOverflow: 'ellipsis',
    //     verticalAlignment: 'top',
    //     wordWrap: 'normal'
    // },
    tooltip: {
        // arrowLength: 10,
        // border:  {
        //     color: '#d3d3d3',
        //     dashStyle: 'solid',
        //     opacity: undefined,
        //     visible: true,
        //     width: 1
        // },
        // color: '#ffffff',
        // container: undefined,
        // contentComponent: null,
        // contentRender: null,
        // contentTemplate: undefined,
        // cornerRadius: 0,
        // customizeTooltip: undefined,
        // enabled: false,
        // font:  {
        //     color: '#232323',
        //     family: 'Segoe UI',
        //     opacity: 1,
        //     size: 12,
        //     weight: 400
        // },
        // format: undefined,
        // interactive: false,
        // opacity: undefined,
        // paddingLeftRight: 18,
        // paddingTopBottom: 15,
        // shadow:  {
        //     blur: 2,
        //     color: '#000000',
        //     offsetX: 0,
        //     offsetY: 4,
        //     opacity: 0.4
        // },
        // zIndex: undefined
    },
    value: 0,
    valueIndicator: {
        // arrowLength: 5,
        // backgroundColor: 'none',
        // baseValue: undefined,
        // beginAdaptingAtRadius: 50,
        // color: null,
        // horizontalOrientation: 'right',
        // indentFromCenter: 0,
        // length: 15,
        // offset: null,
        // secondColor: '#E18E92',
        // secondFraction: 0.4,
        // size: 10,
        // spindleGapSize: 10,
        // spindleSize: 14,
        // text:  {
        //     customizeText: undefined,
        //     font:  {
        //         color: null,
        //         family: 'Segoe UI',
        //         opacity: 1,
        //         size: 14,
        //         weight: 400
        //     },
        //     format: undefined,
        //     indent: 0
        // },
        // type: 'rectangleNeedle',
        // verticalOrientation: 'bottom',
        // width: 2
    }
};
